import { StyleSheet } from 'react-native'

import { Fonts, Colors } from '@vfgroup-oneplatform/foundation/Components/Themes'

const styles = StyleSheet.create({
  errorContainer: {
    paddingVertical: 30,
    paddingHorizontal: 10,
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  errorText: theme => ({
    fontFamily: Fonts.type.VFFont,
    fontSize: Fonts.size.h6,
    color: theme.colors.textColorTwo,
    marginVertical: 20,
    textAlign: 'center',
  }),
  tryAgainContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  tryAgainText: {
    fontFamily: Fonts.type.VFFont,
    fontSize: Fonts.size.h6,
    color: Colors.vfRed,
    marginRight: 5,
  },
})

export default styles
